/*eslint-disable */
import {
  mapGetters
} from 'vuex'; 
const $ = window.jQuery = require('jquery'); 
import toast from '../../../services/toast';
export default {
  name: 'sa-organization-user-details',
  components: {},
  props: [],
  data () {
    return {
      orgUserDetailsById:{},
      nextStep:'',
      loadmoreData: {},
      userLoading: false,
      DeleteId:'',
      checkDataTaskModal:false,
      userTaskList:{},
      userTaskListResults:[]
    }
  },
  computed: {
  ...mapGetters([
    'SaorgUserDetailsByIdGetters',
    'SaUserTaskListGetters'
  ]),
  getOrgDetailsByIdDetailsFun(){
    return this.orgUserDetailsById = this.$store.getters.SaorgUserDetailsByIdGetters.data
  },
  getUserTaskListedFun(){
    return this.userTaskList = this.$store.getters.SaUserTaskListGetters.data
  },
  SetIntialStatus() {
    if (this.userTaskList != undefined) {
      this.nextStep = this.userTaskList.next
      this.userTaskListResults = this.userTaskList.results
    }
  }
  },
  mounted () {
    this.getOrgDetailsByIdDetailsFun
    this.getUserTaskListedFun
    this.SetIntialStatus
  },
  methods: {
    getRemoveListAgain() {
      this.$store.dispatch('getSaUserTaskListFun', {id:this.$route.params.saUserDetailsId}).then((res) => {
        this.userTaskList = this.$store.getters.SaUserTaskListGetters.data
      }).catch((err) => {
      })
    },
    showRemovedTaskModalFun(id){
    $("body").addClass("task_modal_actv");
    this.checkDataTaskModal = true
    this.DeleteId = id
  },
  removeModalItemConfirmFun(){
    this.$store.dispatch('removeTaskDetailsFun', {
      id: this.DeleteId,
    })
    .then((res) => {
      if (res.status == '200') {      
        toast.success(res.data.msg); 
        $("body").removeClass("task_modal_actv");
        this.getRemoveListAgain()
        this.checkDataTaskModal = false
        this.DeleteId = ''
      }
    }).catch((err) => {
      toast.error(err.data.user_msg);  
    })
  return;
  },
  closeRemoveItemModalFun(){
    $("body").removeClass("task_modal_actv");
    this.checkDataTaskModal = false
    this.DeleteId = ''
  }
  },
  watch:{
    getOrgDetailsByIdDetailsFun(){
      return this.orgUserDetailsById = this.$store.getters.SaorgUserDetailsByIdGetters.data
    },
    getUserTaskListedFun(){
      return this.userTaskList = this.$store.getters.SaUserTaskListGetters.data
    },
    SetIntialStatus() {
      if (this.userTaskList != undefined) {
        this.nextStep = this.userTaskList.next
        this.userTaskListResults = this.userTaskList.results
      }
    }
  }
}


